module.exports = __webpack_public_path__ + "img/Niue.fef147d4.gif";